import {
  ExecEdLeadFormProps,
  UseExecEdLeadForm,
  ExecEdLeadFormVariants,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "execEdLeadForm";

const useExecEdLeadForm: UseExecEdLeadForm = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdLeadFormProps;
    variantCustomId: ExecEdLeadFormVariants;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        headerText: "",
      },
    };
  }

  return {
    isLoading,
    variant: value?.variantCustomId,
    data: {
      headerText: value?.data.headerText || "",
    },
  };
};

export default useExecEdLeadForm;
